module.exports = __webpack_public_path__ + "media/images/athletes/2822-1713a8148d315b833c6b3293893f69cb.png";